import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { TaskBlockHeader } from '~/components/blocks/TaskBlockHeader'
import { UsedCommandType } from '~/constants/commands'
import { useTaskId } from '~/hooks'
import { useConversationMetadata } from '~/hooks/conversation/useConversationMetadata'
import { useTaskProgress } from '~/hooks/task/useTaskProgress'
import { AgentTaskStatus, agentTaskStatusFromJSON, agentTaskStatusToJSON } from '~/protos/agents'
import { TaskStatuses } from '~/constants/task-status'
import { toCamelCase } from '~/utils/shared'
import { cm } from '~/utils/utils'
import { CampaignTaskDuration } from './CampaignTaskDuration'
import { CampaignTaskProgressBar } from './CampaignTaskProgressBar'

dayjs.extend(duration)

export interface CampaignTaskBlockProps {
  children: Block[]
  fields: {
    task_id: number
    status: keyof typeof AgentTaskStatus
    title: string
    created_time: number
  }
}

export const getStatusText = (status: string) => {
  if (status === agentTaskStatusToJSON(AgentTaskStatus.AGENT_INTERNAL_STATUS)) {
    return 'In Progress'
  }
  const parsed = agentTaskStatusFromJSON(status)
  return TaskStatuses[parsed]?.label || toCamelCase(status)
}

export const renderStatusBadge = (status: string) => {
  return (
    <div
      className={cm(
        'task-status font-semibold text-white',
        'bg-[rgb(0,0,0,0.2)] rounded px-2 py-[5px]'
      )}
    >
      {getStatusText(status)}
    </div>
  )
}

export function CampaignTaskBlock({ fields }: CampaignTaskBlockProps) {
  const progress = useTaskProgress()
  const { command, branch } = useConversationMetadata()
  const taskId = useTaskId()

  return (
    <div className='task mb-8 pt-8 px-5 w-full sticky top-0 z-40 bg-[#fbfbfb]'>
      <div className='task-info w-full max-w-xl space-y-2 pb-4'>
        <TaskBlockHeader
          command={command as UsedCommandType}
          taskId={taskId}
          branch={branch as string}
          isS3Task={false}
          s3UploadedPath={''}
          repositoryNames={''}
        />
        <div className='mx-[10px]'>
          <CampaignTaskProgressBar
            percentage={progress || 0}
            taskStatus={agentTaskStatusFromJSON(fields.status)}
          />
        </div>
        <div className='flex justify-between items-center mx-[10px] text-sm text-gray-500'>
          <div className='created-time'>
            {dayjs(fields.created_time).format('YYYY-MM-DD HH:mm')}
          </div>
          <CampaignTaskDuration createdTime={fields.created_time} />
        </div>
      </div>
      <hr className='mx-[10px]' />
    </div>
  )
}
